<div class="vig-header">
  <div class="vig-header--logo">
    <img class="vig-header--logo__image" src="assets/images/logo--white__wide-270x80.png" width="270" height="80" alt="Vigilant Logo" />
  </div>
  <div class="vig-header--breadcrumb">
    @if (breadcrumbItems.length > 0) {
      <p-breadcrumb [homeAriaLabel]="'Home'" [home]="breadcrumbHome" [model]="breadcrumbItems" />
    }
  </div>
  <div class="vig-header--avatar">
    <div>
      <p-button
        pTooltip="Toggle color mode"
        tooltipPosition="left"
        [showDelay]="400"
        [icon]="darkMode ? 'pi pi-moon' : 'pi pi-sun'"
        [rounded]="true"
        [severity]="darkMode ? 'secondary' : 'contrast'"
        (click)="onToggleDarkMode()"
      />
    </div>
    @if (_userLoggedIn && (avatarLabel || avatarIcon)) {
      <div>
        <p-avatar
          [label]="avatarLabel"
          [icon]="avatarIcon"
          [pTooltip]="avatarTooltip"
          tooltipPosition="left"
          [showDelay]="400"
          [style]="{ 'background-color': 'var(--color-primary-dark)', color: 'var(--color-light)' }"
          size="large"
          shape="circle"
          (click)="avatarActionMenu.toggle($event)"
        />
        <p-menu #avatarActionMenu [model]="avatarActions" [popup]="true" [appendTo]="'body'" />
      </div>
    }
  </div>
</div>
